import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

// interface
import { ClientInfos } from '../interfaces/client-infos'

// services
import { ClientsService } from '../services/clients.service'

@Component({
selector: 'app-client-info',
templateUrl: './client-infos.component.html',
styleUrls: ['./client-infos.component.scss']
})
export class ClientInfosComponent implements OnInit {
	@Input() public client;
	@BlockUI() blockUI: NgBlockUI;

	clientInfos: ClientInfos;
	orderReady: boolean = false;

	constructor(
		public activeModal: NgbActiveModal,
		private toastrService: ToastrService,
		private clientsService: ClientsService
	) { }

	ngOnInit(): void {
		this.getClient();
	}

	getClient(): void {
		this.blockUI.start('Loading');

		this.clientsService.getClientInfos(this.client.id).subscribe(
			(res) => {
				if (res.success) {
					this.clientInfos = res.data;
					this.blockUI.stop();
					this.orderReady = true
				} else {
					this.blockUI.stop();          
					if (res.errorSet.includes('INVALID_PARAMS')) {
						this.toastrService.error('Les paramètres sont invalides');			
					} else if (res.errorSet.includes('CLIENT_NOT_FOUND')) {
						this.toastrService.error(`La commande n°${this.client.id} n'existe pas`);
					} else if (res.errorSet.includes('ERROR_SERVER')) {
						this.toastrService.error('Une erreur serveur est survenue');	
					} else {
						this.toastrService.error('Une erreur s\'est produite');
					}
					this.activeModal.close();
				}
			},
			(error) => {
				this.blockUI.stop();
				// console.error(error);
				this.toastrService.error('Une erreur s\'est produite');
				this.activeModal.close();
			}
		);
	}
}
